var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHourglass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.55725 1.66667H16.276C16.4917 1.66667 16.6666 1.84157 16.6666 2.05729V2.83854C16.6666 3.05427 16.4917 3.22917 16.276 3.22917H16.1458C16.1458 5.83659 15.1074 8.62041 12.9824 10C15.098 11.3735 16.1458 14.1483 16.1458 16.7708H16.276C16.4917 16.7708 16.6666 16.9457 16.6666 17.1615V17.9427C16.6666 18.1584 16.4917 18.3333 16.276 18.3333H4.55725C4.34153 18.3333 4.16663 18.1584 4.16663 17.9427V17.1615C4.16663 16.9457 4.34153 16.7708 4.55725 16.7708H4.68746C4.68746 14.1634 5.72581 11.3796 7.85087 10C5.73525 8.62653 4.68746 5.85169 4.68746 3.22917H4.55725C4.34153 3.22917 4.16663 3.05427 4.16663 2.83854V2.05729C4.16663 1.84157 4.34153 1.66667 4.55725 1.66667ZM10.4164 10.7804C8.11524 10.7804 6.24975 13.4621 6.24975 16.77H14.5831C14.5831 13.4621 12.7176 10.7804 10.4164 10.7804Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglass);
export default __webpack_public_path__ + "static/media/hourglass.57fcbef042c3b9641cd4ff8ddb737bdf.svg";
export { ForwardRef as ReactComponent };